module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "placeholder": "Select Statistic"
    },
    on: {
      "change": _vm.openGroup
    },
    model: {
      value: (_vm.stat),
      callback: function($$v) {
        _vm.stat = $$v
      },
      expression: "stat"
    }
  }, _vm._l((_vm.codes.statcodes), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Open")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Refresh")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "cell-style": {
        height: '32px'
      },
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Created",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "details",
      "label": "Input",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "align": "right",
      "label": "Total",
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.total != 0) ? scope.row.total : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "added",
      "align": "right",
      "label": "Added",
      "width": "65"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.added != 0) ? scope.row.added : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modified",
      "align": "right",
      "label": "Modified",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.modified != 0) ? scope.row.modified : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activated",
      "align": "right",
      "label": "Activated",
      "width": "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.activated != 0) ? scope.row.activated : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deleted",
      "align": "right",
      "label": "Deleted",
      "width": "75"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.deleted != 0) ? scope.row.deleted : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errors",
      "align": "right",
      "label": "Errors",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.errors != 0) ? scope.row.errors : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errors",
      "align": "right",
      "label": "Skipped",
      "width": "72"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.skipped != 0) ? scope.row.skipped : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "78",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.showLog(scope.row)
            }
          }
        }, [_vm._v("Log")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Messages & Errors",
      "visible": _vm.MessagesVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.MessagesVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "25"
    },
    model: {
      value: (_vm.messages),
      callback: function($$v) {
        _vm.messages = $$v
      },
      expression: "messages"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.MessagesVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a4f7199"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/xstat.vue
// module id = 649
// module chunks = 1